import { useDragLayer } from "react-dnd";
import { DNDItem } from "./DNDSortableListItem";
import { createElement } from "react";

export function DNDPreview({elementTag}: Props)
{
    const { item, isDragging, offset } = useDragLayer((monitor) => (
    {
        item: monitor.getItem() as DNDItem,
        isDragging: monitor.isDragging(),
        offset: monitor.getSourceClientOffset(),
    }));

    if (!isDragging || !item || !offset)
    {
        return null;
    }

    return createElement(
        elementTag,
        {
            children: item.preview,
            style:
            {
                position: 'fixed',
                left: offset.x,
                top: offset.y,
                pointerEvents: 'none',
                transform: 'translate(-50%, -50%)',
                background: 'rgba(0,0,0,0.1)',
            },
        }
    );
}

interface Props
{
    elementTag: string;
};